/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import './Groups.less';
import { GroupModalActions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const GroupBannerInfo = ({
  record,
  scheduleEvents,
  onGroupModalActionClick,
  setSetupBanner,
  setActiveTab,
  isStaffAdmin,
  isStaff,
}) => {
  const trans = useSelector(translator);

  useEffect(() => {
    // Check if the setup banner should be displayed
    if (record && scheduleEvents) {
      const hasNoMembers = record.invited_contacts?.length === 0;
      const hasNoScheduleEvents = scheduleEvents.length === 0;
      setSetupBanner(hasNoMembers || hasNoScheduleEvents);
    }
  }, [record, scheduleEvents]);

  const addGroupMemberHandler = () => {
    onGroupModalActionClick(GroupModalActions.addMember);
    setActiveTab('2'); // Switch to the member tab
  };

  return (
    <>
      {' '}
      {record?.scheduled_events_count === 0 ? (
        <div className="group-setup-container">
          <div className="group-setup-row top">
            <span className="group-setup-title">{trans('GROUPALMOSTFULLYSETUP')}</span>
            <span className="group-setup-paragraph">{trans('SOMESTEPSREQUIRESYOURATTENTION')}</span>
          </div>

          <div className="group-setup-row bottom">
            {record?.invited_contacts?.length === 0 && isStaffAdmin ? (
              <div className="group-setup-info-block">
                <span className="group-setup-info-label" onClick={addGroupMemberHandler}>
                  {trans('ADDGROUPMEMBERS')}
                </span>
              </div>
            ) : null}
            {scheduleEvents?.length === 0 ? (
              <div className="group-setup-info-block">
                <span
                  className="group-setup-info-label"
                  onClick={() => onGroupModalActionClick(GroupModalActions.createScheduleCall)}
                >
                  {trans('SCHEDULEFIRSTCALL')}
                </span>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default GroupBannerInfo;
